import { supabase } from '../supabaseClient'
import type {
  CalibrationSessionType,
  CalibrationStatus,
  HeartRateRecoveryDelta,
  TrainingGoal,
  VelocityDeviationEntry,
} from '../calibrationTypes'
import type { CalibrationProfileInput } from './calendarLayout'

export type CalibrationProfile = CalibrationProfileInput & {
  training_goal: TrainingGoal | null
  onboarding_completed: boolean
}

export async function loadCalibrationProfile(
  userId: string,
): Promise<{ profile: CalibrationProfile | null; error: string | null }> {
  const { data, error } = await supabase
    .from('profiles')
    .select(
      'weekly_commitment, rest_days, meal_prep_day, calibration_status, calibration_completed_sessions, training_goal, onboarding_completed',
    )
    .eq('id', userId)
    .single()

  if (error) return { profile: null, error: error.message }

  return {
    profile: {
      weekly_commitment: Number(data.weekly_commitment ?? 3),
      rest_days: (data.rest_days as string[]) ?? [],
      meal_prep_day: String(data.meal_prep_day ?? 'sunday'),
      calibration_status: (data.calibration_status as CalibrationStatus) ?? 'not_started',
      calibration_completed_sessions: Number(data.calibration_completed_sessions ?? 0),
      training_goal: (data.training_goal as TrainingGoal | null) ?? null,
      onboarding_completed: Boolean(data.onboarding_completed),
    },
    error: null,
  }
}

export type CalibrationSessionMetricsInput = {
  sessionType: CalibrationSessionType
  tempoComplianceRate?: number | null
  velocityDeviationHistory?: VelocityDeviationEntry[]
  workDensityDropoff?: number | null
  heartRateRecoveryDelta?: HeartRateRecoveryDelta
  cardioPaceHrRatio?: number | null
  mobilityFlags?: string[]
}
